import { useConfig } from '@/composables';
import { createGtm } from '@gtm-support/vue-gtm';
import { App } from 'vue';
import { Router } from 'vue-router';

/**
 * Initialise the Google Tag Manager plugin.
 * Further reading: src/common/helpers/gtm/README.md.
 *
 * @param app The Vue application instance
 * @param router The Vue router instance
 */
export const initGtm = (app: App<Element>, router: Router) => {
  const containerId = useConfig().value.googleTagManager?.containerId;

  if (containerId) {
    app.use(
      createGtm({
        id: containerId,
        vueRouter: router,
      })
    );
  }
};
